import { FC } from "react";

export const ValidationPopupContentDescription: FC<{
  contentMessageText: string;
}> = ({ contentMessageText }) => {
  return <div className="text-base text-indigo-800">{contentMessageText}</div>;
};
